import { useMutation } from "@apollo/client"
import { USER_EDIT } from "../queries/userEdit"
import { toast } from "@/components/ui/use-toast"
import { useAuthContext } from "@/contexts/AuthContext"

interface UserEditAddress {
  id?: number
  name: string
  address: string
  countryId: number
  regionId: number
  locationId: number
}

export interface UserEditInput {
  id: number
  name?: string
  firstSurname?: string
  lastSurname?: string
  birthday?: string
  genderId?: number
  email: string
  active?: number
  categoryId?: number
  documentNumber?: string
  documentNumberType?: string
  phone?: string
  address?: UserEditAddress
}

export const useUserEdit = () => {
  const { refetch } = useAuthContext()
  const [editUser, { loading, error }] = useMutation(USER_EDIT, {
    onCompleted: (data) => {
      if (data.UserEdit.status.success) {
        toast({
          title: "Perfil actualizado",
          description: "La información ha sido actualizada correctamente",
          variant: "success",
        })
        // Refetch user data to update the context
        refetch?.()
      } else {
        toast({
          title: "Error al actualizar",
          description: data.UserEdit.status.detail || "Ocurrió un error al actualizar tu perfil",
          variant: "destructive",
        })
      }
    },
    onError: () => {
      toast({
        title: "Error",
        description: "Ocurrió un error al actualizar tu perfil",
        variant: "destructive",
      })
    },
  })

  const updateUser = (input: UserEditInput) => {
    return editUser({
      variables: {
        UserEditInput: input,
      },
    })
  }

  return {
    updateUser,
    loading,
    error,
  }
}
